import Handler from "../Handler";

class PrivateTableCreateGameDefFailureHandler extends Handler {
  execute(message) {
    this.service.processPrivateTableCreateGameDefFailure();
  }
}
export default PrivateTableCreateGameDefFailureHandler;
// PTCreateGDF#